import React from "react";

import eventImg from "../assets/images/eventImg.jpg";

import classes from "./RightSide.module.css";
import { useTranslation } from "react-i18next";

const RightSide = () => {
  const { t } = useTranslation();

  return (
    <div className={classes["wrapper"]}>
      <div className={classes["about-event"]}>
        <h3 className={classes["title"]}>{t("Events in our school")}</h3>
        <h3 className={classes["descrtion"]}>
          Every week we develop not only hard, but also software: we pump the
          skill of communication, presentation and management. <br />
          <br />
          {t("Events for students will be very interesting and useful .")}
        </h3>
      </div>
      <div className={classes["img-wrapper"]}>
        <img className={classes["img"]} src={eventImg} alt="event img" />
        <img className={classes["img"]} src={eventImg} alt="event img" />
      </div>
    </div>
  );
};

export default RightSide;
